import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Col, Form, Image, Modal, Row } from "antd";
import { useCallback, useState } from "react";
import { EUserRole, TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../others/i18n.js";
import { spacing } from "../../../../../styles/spacing.js";
import { trimStringWithEllipsis } from "../../../../../util/string.js";
import { getFieldNameTranslated } from "../../../../../util/template/translation.js";
import { MediaManager } from "../../media/mediaManager.js";
import { FormFieldVisibilityWrapper } from "../formFieldVisibilityWrapper.js";
function FormFieldTemplateLogo() {
    const { t } = useTranslation();
    const [isLogoModalOpen, setIsLogoModalOpen] = useState(false);
    const onVisibleChange = useCallback((visible)=>{
        setIsLogoModalOpen(visible);
    }, []);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: TemplateMetaDataField.Logo,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(TemplateMetaDataField.Logo, t),
            shouldUpdate: (prev, next)=>prev.logo !== next.logo,
            required: true,
            children: ({ getFieldValue, setFieldValue })=>{
                const selectedLogo = getFieldValue(TemplateMetaDataField.Logo);
                return /*#__PURE__*/ _jsxs(Row, {
                    style: {
                        width: "100%",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Col, {
                            hidden: !selectedLogo,
                            style: {
                                paddingRight: spacing.layout.content.paddingMedium,
                                textAlign: "center"
                            },
                            children: selectedLogo && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Image, {
                                        width: 100,
                                        src: selectedLogo.downloadUrl,
                                        alt: selectedLogo.name,
                                        style: {
                                            marginTop: spacing.layout.image.margin,
                                            marginBottom: spacing.layout.image.margin
                                        },
                                        preview: false
                                    }),
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: trimStringWithEllipsis(selectedLogo.name.split("/").pop(), 32)
                                    }),
                                    /*#__PURE__*/ _jsx("br", {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Col, {
                            style: {
                                flex: 1
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "primary",
                                    onClick: ()=>setIsLogoModalOpen(true),
                                    children: selectedLogo ? t("Change logo") : t("Select logo")
                                }),
                                /*#__PURE__*/ _jsx(Form.Item, {
                                    noStyle: true,
                                    name: "_logoValidation",
                                    rules: [
                                        {
                                            validator: ()=>{
                                                const logo = getFieldValue(TemplateMetaDataField.Logo);
                                                if (!logo) {
                                                    return Promise.reject();
                                                }
                                                return Promise.resolve();
                                            },
                                            message: t("Please choose a proper logo for better recognition.")
                                        }
                                    ],
                                    dependencies: [
                                        TemplateMetaDataField.Logo
                                    ],
                                    children: /*#__PURE__*/ _jsx(Modal, {
                                        title: t("Select logo"),
                                        centered: true,
                                        onOk: ()=>{
                                            setIsLogoModalOpen(false);
                                        },
                                        onCancel: ()=>{
                                            setFieldValue(TemplateMetaDataField.Logo, undefined);
                                            setIsLogoModalOpen(false);
                                        },
                                        open: isLogoModalOpen,
                                        width: "80%",
                                        okButtonProps: {
                                            disabled: !selectedLogo
                                        },
                                        forceRender: true,
                                        children: /*#__PURE__*/ _jsx(Form.Item, {
                                            name: TemplateMetaDataField.Logo,
                                            dependencies: [
                                                "logoValidation"
                                            ],
                                            children: /*#__PURE__*/ _jsx(MediaManager, {
                                                isPreloadEnabled: isLogoModalOpen,
                                                onVisibleChange: onVisibleChange
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
}
export { FormFieldTemplateLogo };
